import * as React from 'react';
import {
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   CustomHeading,
   History,
   BulletList,
   OrderedList,
   ListItem,
   Blockquote,
   CustomMention,
   CodeBlock,
   MediaManager,
   HardBreak,
   CustomSubscript,
   CustomSuperscript,
} from '../extensions';
import { Editor } from '@tiptap/react';
import { MenuSeparator } from '../components/MenuSeparator';
import { TiptapMenubar } from '../components/TiptapMenubar';
import { MenuDropdown } from '../components/MenuDropdown';
import {
   BoldButton,
   ItalicButton,
   CodeButton,
   LinkButton,
   CodeBlockButton,
   BlockquoteButton,
   BulletListButton,
   OrderedListButton,
   IndentButton,
   UnindentButton,
   UndoButton,
   RedoButton,
   InsertImageButton,
} from '../components/buttons';
import type { TiptapExtension } from '../tiptap';

export const AnswersExtensions: Array<TiptapExtension> = [
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   CustomHeading,
   History,
   BulletList,
   OrderedList,
   ListItem,
   Blockquote,
   CustomMention,
   CodeBlock,
   MediaManager,
   HardBreak,
   CustomSubscript,
   CustomSuperscript,
];

export const AnswersMenuBar = (props: { editor: Editor }) => {
   const editor: Editor = props.editor;
   return (
      <TiptapMenubar>
         <BoldButton editor={editor} />
         <ItalicButton editor={editor} />
         <CodeButton editor={editor} />
         <LinkButton editor={editor} />
         <MenuSeparator />
         <MenuDropdown editor={editor} />
         <MenuSeparator />
         <CodeBlockButton editor={editor} />
         <BlockquoteButton editor={editor} />
         <BulletListButton editor={editor} />
         <OrderedListButton editor={editor} />
         <UnindentButton editor={editor} />
         <IndentButton editor={editor} />
         <MenuSeparator />
         <InsertImageButton editor={editor} />
         <MenuSeparator />
         <UndoButton editor={editor} />
         <RedoButton editor={editor} />
      </TiptapMenubar>
   );
};
